module.exports = __webpack_public_path__ + "assets/webgl/skybox.jpg.59e8dfaa.webp";